import React from 'react';
import ReactDOM from 'react-dom';
import {
  HashRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import { configure } from 'mobx';
import { Provider } from 'mobx-react';
import { LocaleProvider } from 'antd';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import * as stores from './stores';
import './index.css';

// 组件部分
import AuthorizedRoute from './layout/AuthorizedRoute';
import Login from './pages/auth/login/Login';
import Register from './pages/auth/Register/Register';
import ForgetPW from './pages/auth/ForgetPW/ForgetPW';
import ChooseRole from './pages/auth/ChooseRole';
import Layout from './layout/Layout';
import TransferFile from './pages/agent/TransferFile';
import RechargeFinish from './pages/agent/AccountCenter/RechargeFinish';


moment.locale('zh-cn');
const RouteFallback = props => {
  return (
    <Redirect
      to={{
        pathname: '/agent',
        from: props.location
      }}
    />
  );
};

ReactDOM.render(
  <LocaleProvider locale={zhCN}>
    <Provider {...stores}>
      <Router>
        <Switch>
          <AuthorizedRoute path="/agent" component={Layout} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/forgetPW" component={ForgetPW} />
          <Route exact path="/register" component={Register} />
          <Route exact path="/chooseRole" component={ChooseRole} />
          <Route exact path="/transferFile" component={TransferFile} />
          <Route exact path="/rechargeFinish" component={RechargeFinish} />
          <Route component={RouteFallback} />
        </Switch>
      </Router>
    </Provider>
  </LocaleProvider>,
  document.getElementById('root')
);

configure({
  enforceActions: 'always'
});



// WEBPACK FOOTER //
// ./src/index.js